import { Route, Routes, Outlet, Navigate } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { BundlesListWrapper } from './bundles-list/BundlesList'
import AccountPage from '../../modules/accounts/AccountPage'
import { AccountHeader } from '../../modules/accounts/AccountHeader'
import { Settings } from '../../modules/accounts/components/settings/Settings'
import { Overview } from '../../modules/accounts/components/Overview'

const bundlesBreadcrumbs: Array<PageLink> = [
  {
    title: 'Bundle Management',
    path: '/admin/pages/bundles',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const accountBreadCrumbs: Array<PageLink> = [
  {
    title: 'Account',
    path: '/admin/pages/bundles/overview',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const BundlesPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          // path='bundles'
          index
          element={
            <>
              <PageTitle breadcrumbs={bundlesBreadcrumbs}>Bundles list</PageTitle>
              <BundlesListWrapper />
            </>
          }
        />

        <Route
          element={
            <>
              <AccountHeader />
              <Outlet />
            </>
          }
        >
          <Route
            path='overview'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Overview</PageTitle>
                <Overview />
              </>
            }
          />
          <Route
            path='settings'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Settings</PageTitle>
                <Settings />
              </>
            }
          />
          <Route index element={<Navigate to='/admin/pages/bundles/overview' />} />
        </Route>

      </Route>
      <Route index element={<Navigate to='/admin/pages/bundles' />} />
    </Routes>
  )
}

export default BundlesPage
